/**
 * Bundled font for the batched labels. Troika needs a real font file it can
 * parse (woff/ttf/otf); without one it would fetch fonts from a public CDN at
 * runtime, which this app must not do. Roboto is already the app's UI font.
 */
export { default as LABEL_FONT_URL } from '@fontsource/roboto/files/roboto-latin-400-normal.woff?url'

/** Matches the line spacing `Text3DThree` uses in `ModelElementLabels` */
export const LABEL_LINE_HEIGHT = 1.4

/** SDF resolution per glyph - higher is sharper but costs atlas space */
export const LABEL_SDF_GLYPH_SIZE = 64

/** Screen-space thickness of the label border, in pixels */
export const LABEL_BORDER_THICKNESS_PX = 1.5

/** Pushes the background rectangle behind the text so the text wins the depth test */
export const LABEL_BACKGROUND_DEPTH_OFFSET = 0.002

/**
 * Alpha below which a glyph fragment is discarded in occluding mode. Only the
 * solid core of each glyph then writes depth.
 */
export const LABEL_OCCLUSION_ALPHA_TEST = 0.5

/**
 * Depth step between consecutive labels in occluding mode. Coplanar labels
 * cannot occlude each other (equal depth passes the default depth test), so
 * each label is nudged along its normal to give the depth buffer something to
 * resolve. Must exceed `LABEL_BACKGROUND_DEPTH_OFFSET` so a label's background
 * can cover the text of the labels behind it.
 */
export const LABEL_OCCLUSION_DEPTH_STEP = 0.003

/**
 * Pulls the label background towards the viewer in the depth buffer.
 *
 * Element bodies carry polygon offsets of their own - vertical slabs use -1 in
 * `ModelMesh` - which would otherwise win the depth comparison against a label
 * that sits geometrically in front of them. `PointShapesMesh` derives an offset
 * from `renderOrder`, but its formula (`-1 * (1 - 1 / renderOrder)`) comes out at
 * exactly 0 for `renderOrder` 1, so the background needs its own.
 */
export const LABEL_BACKGROUND_POLYGON_OFFSET = -4

export const LABEL_BACKGROUND_RENDER_ORDER = 1
export const LABEL_TEXT_RENDER_ORDER = 2
